import React from 'react';
import block from 'bem-cn-lite';
import {FormFieldCheckbox, FormFieldCheckboxProps} from '@yandex-data-ui/cloud-components';
import {HTML} from '@doc-tools/components';

import './FormFieldAgreementCheckBox.scss';

const b = block('FormFieldAgreementCheckBox');

export const FormFieldAgreementCheckBox: React.FC<FormFieldCheckboxProps> = ({
    size = 'l',
    text,
    className,
    ...rest
}) => (
    <FormFieldCheckbox
        className={b(null, className)}
        controlClassName={b('control')}
        size={size}
        renderContent={() => <HTML>{text}</HTML>}
        {...rest}
    />
);
